var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Bitácora de siniestro")]),_vm._v(" "),_c('div',{staticClass:"md-layout"},[_c('BinnacleEntriesExtranet',{ref:"binnacle-timeline",attrs:{"submitting":_vm.submitting,"entries":_vm.extranetBinnacleEntries,"taggableUsers":_vm.taggableUsers,"reverse":"","show-new-comment-input":_vm.$canView('Sinister', 'extranetbinnacle'),"add-new-comment-input":_vm.$canAdd('Sinister', 'extranetbinnacle')},on:{"update:newComment":_vm.addComment}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/extranet/Binnacle.vue